import React from "react";
import "./SettingsTab.css";

export default function SettingsTab() {
  return <div className="settings-tab">SettingsTab</div>;
}
